import { Capacitor } from '@capacitor/core';

export const isAndroidPluginAvailable = (name: string) => {
  return Capacitor.getPlatform() === 'android' && Capacitor.isPluginAvailable(name);
};